import React from "react";


const SelectFieldFilter = (props) => {
    
    const handleSelection = (key, value) => {
        props.callback(key, value);
    }

    return (
        <div>
            <p>{props.label}</p>
            <select value={props.currentSelection} onChange={(e) => handleSelection(props.filterKey, e.target.value)} >
                {props.options.map((option) => 
                    <React.Fragment key={`${props.label}_${option}_fitler`}>
                        <option value={option}>{option}</option>
                    </React.Fragment>
                    )
                } 
            </select>
        </div>
    )
}

export default SelectFieldFilter;